import { Stack, Typography } from "@mui/material";
import WhiteCard from "../WhiteCard";
import { PatientProfile } from "src/api/types";
import TextMessagesList from "./components/TextMessages";
import NewSmsMessageForm from "./components/NewSmsMessageForm";

interface Props {
  patient: PatientProfile;
  allowMessaging?: boolean;
  onSuccess?: () => void;
}

const SmsMessaging = ({ patient, allowMessaging = true, onSuccess }: Props) => {
  return (
    <WhiteCard gap={1}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="subtitle2">SMS MESSAGES</Typography>
      </Stack>

      <Stack maxHeight="657px" height={"100%"} sx={{ overflowY: "auto" }}>
        <TextMessagesList patient={patient} />
        {allowMessaging ? (
          <NewSmsMessageForm
            onSuccess={onSuccess}
            phoneNumber={patient.profile.phone_number}
            patientProfileId={patient.profile_id}
          />
        ) : null}
      </Stack>
    </WhiteCard>
  );
};

export default SmsMessaging;
